export enum ChapterSelector{
	BASIC = 'BASIC',
	STANDARD = 'STANDARD',
	TREAT_TREAT = 'TREAT_TREAT',
	TREAT_CHECK = 'TREAT_CHECK',
	TREAT_RA = 'TREAT_RA',
	TREAT_DPIA = 'TREAT_DPIA',
	TREAT_LIA = 'TREAT_LIA',
}
